const dietToAllergens = {
  'GLUTEN FREE': ['WHEAT'],
  'DAIRY FREE': ['DAIRY'],
  VEGETARIAN: ['FISH', 'PORK', 'SHELLFISH'],
  VEGAN: ['FISH', 'PORK', 'SHELLFISH', 'DAIRY', 'EGGS'],
};

export const dietPrefIncludesAllergen = (dietTag, allergenTag) =>
  dietToAllergens[dietTag] && dietToAllergens[dietTag].includes(allergenTag);



// WEBPACK FOOTER //
// ./src/helpers/allergens.js